import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xs text-gray-500" }
const _hoisted_2 = { class: "text-xs text-gray-500" }
const _hoisted_3 = { class: "text-xs text-gray-500" }
const _hoisted_4 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!

  return (_ctx.column.key === 'fullName')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_router_link, {
          to: `/new-dispatcher/couriers/${_ctx.row.id}`,
          class: "text-blue-600 font-medium",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.row.iin), 1)
      ], 64))
    : (_ctx.column.key === 'company')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.row.company)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.cut(_ctx.row.company.name, 15)), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" - ")
              ], 64))
        ], 64))
      : (_ctx.column.key === 'dispatcherSector')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(_ctx.row.dispatcherSector.name), 1)
          ], 64))
        : (_ctx.column.key === 'car')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_ctx.row.car)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.row.car.number), 1),
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.row.car.model), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ], 64))
          : (_ctx.column.key === 'createdAt')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createElementVNode("p", null, _toDisplayString(_ctx.getCreatedAtDate(_ctx.row)), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.getCreatedAtTime(_ctx.row)), 1)
              ], 64))
            : (_ctx.column.key === 'schedule')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (_ctx.row.schedule)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.row.schedule.workTimeFrom) + " - " + _toDisplayString(_ctx.row.schedule.workTimeUntil), 1),
                        _createVNode(_component_cheap, {
                          class: _normalizeClass(["small border-none text-black", {
                    'bg-blue-50': _ctx.row.schedule.shiftId === 1,
                    'bg-green-50': _ctx.row.schedule.shiftId === 2,
                    'bg-yellow-50': _ctx.row.schedule.shiftId !== 1 && _ctx.row.schedule.shiftId !== 2,
                }])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.row.schedule.shift), 1)
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ], 64))
              : (_ctx.column.key === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    (_ctx.row.status)
                      ? (_openBlock(), _createBlock(_component_cheap, {
                          key: 0,
                          class: _normalizeClass(["small", {
                    green: _ctx.row.status.id === 2,
                    yellow: _ctx.row.status.id === 1,
                    red: _ctx.row.status.id === 4,
                }])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.row.status.title), 1)
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                    _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
                  ], 64))
}